import anime from 'animejs/lib/anime.es.js';
import confetti from 'canvas-confetti';

let form = document.querySelector('form.qform');
let darkener = document.querySelector('.response__darkener');
let response = document.querySelector('.response');
let closeButton = document.querySelector('.response__close');

var responseShowing = false;

if (form) {
    form.addEventListener('wpcf7submit', function () {
        responseShowing = true;
        anime({
            targets: darkener,
            opacity: 0.64,
            duration: 200,
            easing: 'easeInQuart',
            begin: function () {
                darkener.style.pointerEvents = 'all';
                darkener.style.visibility = 'visible';
                darkener.classList.add('is-open');
            }
        });
        anime({
            targets: response,
            translateY: [2000, '-50%'],
            duration: 300,
            delay: 100,
            easing: 'easeOutQuart',
            begin: function () {
                response.style.pointerEvents = 'all';
                response.style.visibility = 'visible';
            }
        })
    });

    /* -------------------------------- Chiusura -------------------------------- */
    function closeResponse() {
        if (responseShowing == true) {
            anime({
                targets: darkener,
                opacity: 0,
                duration: 200,
                delay: 100,
                easing: 'easeInQuart',
                complete: function () {
                    darkener.removeAttribute('style');
                    darkener.classList.remove('is-open');
                }
            });
            anime({
                targets: response,
                translateY: ['-50%', 2000],
                duration: 300,
                easing: 'easeInQuart',
                complete: function () {
                    response.removeAttribute('style');
                    response.removeAttribute('class');
                    response.classList.add('response');
                }
            });

            responseShowing = false;
        }
    }

    closeButton.addEventListener('click', closeResponse);
    darkener.addEventListener('click', closeResponse);

    form.addEventListener('wpcf7mailsent', function () {
        response.classList.add('response_success');
        confetti({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.5 }
        });
    })
}